import ErrorPage from '@/components/error/errorPage'
import LoadingScreen from '@/components/loading/loading'
import { useAuthStore } from '@/store/auth'
import { useMemo } from 'react'

export const AppLoader = ({ children }: { children: React.ReactNode }) => {
  const isLoading = useAuthStore((s) => s.isLoading)
  const error = useAuthStore((s) => s.error)

  // Memoize the loading component so it doesn't remount between INITIAL_LOADING and UNAUTHENTICATED states
  const loadingComponent = useMemo(() => <LoadingScreen delay={300} />, [])

  // Show error page if there's an error
  if (error) {
    return <ErrorPage />
  }

  // Return either the memoized loading component or children
  return isLoading ? loadingComponent : children
}
